/** @format */

import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Alert,
  Form,
  Label,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  Jumbotron,
  Badge
} from "reactstrap";
import Icon from "../components/Icon";
import jquery from "jquery";
import dummyProduct from "../data/dummy-item.json";
import Loader from "../components/Loader";
import ProductBottomTabs from "../components/ItemDetailTab";
import SwiperGallery from "../components/SwiperGallery";
import Select from "react-select";
import { cartUrl } from "../global/url";
import Header from "../components/Header";
import Footer from "../components/Footer";
import {
  setCookie,
  getCookie,
  eraseCookie,
  setLocalStorage,
  getLocalStorage,
  getUrlParam,
  setCookieOneHr,
} from "../global/browserFunctions";
import { category, category2 } from "../global/url";
import _ from "underscore";
import { showNotification } from "../global/notification";

class ItemDetails extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    if (!getCookie("log")) {
      //If not logged in, go to login page
      this.GoToPage("/");
    }

    this.state = {
      quantity: 1,
      loading: true, //To show loading spinner
      hidden: true,
      category: { name: "" },
      categoryRoute: "category?id=" + getUrlParam("category"), //Get category id from url param
      product: {},
      quantity: 1,
      name: "",
      price: "",
      yourPrice: "",
      img: [],
      description: "",
      currentIndex: 0,
      bicycleSize: "", //Matrix options selected
      bicycleColor: "",
      bicycleSpeed: "",
      accColor: "",
      accSize: "",
      item_custitembicyclesize: [], //Multiple matrix options
      item_custitembicyclecolor: [],
      item_custitembicyclespeed: [],
      item_custitembicycleaccessorycolor: [],
      item_custitembicycleaccessorysize: [],
      itemFound: false,
      longdescription: "",
      additionalInfo: [],
      SKU: "",
      stockInfo: [],
      stockDetails: [],
      addToCartEnabled: false,
      item_id: "",
      url: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSelect = this.handleSelect.bind(this);

    this.customSelectStyles = {
      //selectbox custom style
      control: (provided, state) => ({
        ...provided,
        border: "1px solid #ced4da",
        borderRadius: "0",
        width: 200,
        cursor: "pointer",
      }),
      indicatorSeparator: (provided, state) => ({
        display: "none",
      }),
      menu: (provided, state) => ({
        ...provided,
        color: "#343a40",
        border: "0 solid #fff",
        borderRadius: 0,
        boxShadow: "0 0 1.2rem rgba(0, 0, 0, .15)",
      }),
      option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
        ...provided,
        backgroundColor: isDisabled
          ? null
          : isSelected
            ? "#bcac76"
            : isFocused
              ? "#eee"
              : null,
        ":active": {
          ...provided[":active"],
          backgroundColor: "#e2dabc",
        },
        cursor: "pointer",
      }),
    };
  }

  GoToPage(path) {
    this.props.history.push(path);
  }

  componentDidMount() {
    var category = getUrlParam("category");
    if (getCookie(category)) {
      //After component render check cookie for item data, if found set page data
      this.setPageDetails();
    } else {
      var category = getUrlParam("category"); //Get category id from params
      var itemID = getUrlParam("id"); //Get item id from params
      var items = this.fetchItems(category, itemID); //Fetch item details
      console.log("NO DATA FOUND");
    }
  }

  setPageDetails() {
    //Set all page data

    var self = this;
    var id = getUrlParam("id");
    var category = getUrlParam("category"); //Get params from the url, the page only works if category and item id is present
    var details = getLocalStorage(category)
      ? JSON.parse(getLocalStorage(category))
      : false;
    if (details) {
      this.setState({ loading: false });
      var category = details.categories[0];
      var items = details.items;

      this.setState({ category: { name: category.name.value } }); //Set category details

      var index = items.findIndex(
        //If using id, an item exist then find the index of the item inn array
        (x) => x.item_internalid.value == id
      );
      var item = items[index];
      //console.log("item", item);
      if (item) {
        this.setState({ product: item }, function () {
          //If item found set product
          self.setItemData(); //set product details in the page
        });

        this.setState({ itemFound: true });
      }
    } else {
      var category = getUrlParam("category");
      var items = this.fetchItems(category, id);
      console.log("NO DATA FOUND");
    }


  }

  setStockInfo() {
    var stockDetails = [];
    var items = this.state.product['child_items'] || {};
    for (var key in items) {
      var detailsObj = {};
      var stockinfo = [];
      var stockObj = {};

      var singleItem = items[key];
      var locations = singleItem.stock_availability || {};
      detailsObj.name = singleItem.item_itemid.value;
      for (var i in locations) {
        if (
          locations[i].item_inventorylocation &&
          locations[i].item_inventorylocation.text
        ) {
          var stockObj = {};
          stockObj.name = locations[i].item_inventorylocation.text;
          stockObj.text = locations[i].item_locationquantityavailable_text.value;
          if (stockObj.text.indexOf('>') || stockObj.text.indexOf('<')) {
            stockObj.text = stockObj.text.replace(/</, '< ');
            stockObj.text = stockObj.text.replace(/>/, '> ')
          }
          stockinfo.push(stockObj);
          detailsObj.details = stockinfo;
        }
      }
      stockDetails.push(detailsObj);
    }
    this.setState({ stockDetails: stockDetails })
  }

  setItemData() {
    var self = this;
    var options = {
      bicycleColor: "item_custitembicyclecolor",
      bicycleSize: "item_custitembicyclesize",
      bicycleSpeed: "item_custitembicyclespeed",
      accSize: "item_custitembicycleaccessorysize",
      accColor: "item_custitembicycleaccessorycolor",
    }; //Matrix options which are predefined by client
    var keys = _.keys(options);
    var value = _.values(options);
    var item = this.state.product;
    for (var i in value) {
      //Loop to create matrix option select box from child items
      var arr = [];

      var childItems = item.child_items || {};
      for (var j in childItems) {
        var obj = childItems[j][value[i]] || { value: "" };
        if (obj.value != "") {
          obj.label = obj.text;
          obj.id = keys[i];
          obj.name = value[i];
          arr.push(obj);
        }
      } //Set obj data {lable:"", id:"", name:""}

      var filteredArr = arr.reduce((acc, current) => {
        //To remove duplicate matrix option if exists
        const x = acc.find((item) => item.value === current.value);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      filteredArr = _.sortBy(filteredArr, "label"); //To sort the options alphabetically
      this.setState({ [value[i]]: filteredArr }, function () {
        self.setItemDetails();
      });
      this.setState(
        { [keys[i]]: filteredArr.length > 0 ? filteredArr[0] : "" },
        function () {
          self.setItemDetails();
        }
      );
    }

    this.setStockInfo();
  }

  fetchItems(id, itemID) {
    //Function to fetch category details if its not found in local storage
    var self = this;
    var currency = getCookie("currency");
    var pricelevel = getCookie("pricelevel") || "5";
    var currencyObj = { "1": "USD", "3": "CAD", 1: "USD", 3: "CAD" }

    var categoryObj = window.CategoryDetails || [];

    this.intervalID = setInterval(function () { //This will load the json file again if we dont get the data first time
      var categoryObj = window.CategoryDetails || {};
      if (categoryObj) {
        clearInterval(self.intervalID)
        self.setState({ loading: false });

        var pageNum = getUrlParam("page") ? Number(getUrlParam("page")) : 1;
        setCookieOneHr(id, true, 1);
        var data = categoryObj[currencyObj[currency]];
        console.log('details', details)
        var details = data[id];


        if (details) {
          var items = details.items;

          var category = details.categories[0]
            ? details.categories[0]
            : { name: {} };
          self.setState({ category: { name: category.name.value } });
          setLocalStorage(id, JSON.stringify(details));

          var index = items.findIndex(
            (x) => x.item_internalid.value == itemID
          );
          var item = items[index];
          // var item = items.find((each) => each.InternalID == id);
          console.log("itemFects", item);
          if (item) {
            self.setState({ product: item }, function () {
              self.setItemData();
            });
            self.setState({ itemFound: true });
          }
        }
      }

    }, 200)
  }

  // fetchItems(id, itemID) {
  //   //Function to fetch category details if its not found in local storage
  //   var self = this;
  //   var currency = getCookie("currency");
  //   var pricelevel = getCookie("pricelevel") || "5";
  //   var query = "&priceLevel=" + pricelevel + "&currencyId=" + currency;
  //   jquery
  //     .ajax({
  //       url: category2 + "&categoryId=" + id + query,
  //       dataType: "jsonp",
  //     })
  //     .done(function (data) {
  //       self.setState({ loading: false });
  //       if (data) {
  //         data = JSON.parse(unescape(data));
  //         if (data.summary.status == "SUCCESS") {
  //           setCookieOneHr(id, true, 1);
  //           var details = data.data;
  //           if (details) {
  //             var items = details.items;

  //             var category = details.categories[0]
  //               ? details.categories[0]
  //               : { name: {} };
  //             self.setState({ category: { name: category.name.value } });
  //             setLocalStorage(id, JSON.stringify(details));

  //             var index = items.findIndex(
  //               (x) => x.item_internalid.value == itemID
  //             );
  //             var item = items[index];
  //             // var item = items.find((each) => each.InternalID == id);
  //             console.log("itemFects", item);
  //             if (item) {
  //               self.setState({ product: item }, function () {
  //                 self.setItemData();
  //               });
  //               self.setState({ itemFound: true });
  //             }
  //           }
  //         } else {
  //           console.log("err in fetch");
  //         }
  //       } else {
  //         console.log("err in fetch");
  //       }
  //     });
  // }

  handleChange(e) {
    //To handle quantity change
    var target = e.target;
    var name = target.name;
    var value = target.value;
    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ loading: true });
    var self = this;
    var matrixOption = {
      item_custitembicycleaccessorycolor: this.state.accColor,
      item_custitembicycleaccessorysize: this.state.accSize,
      item_custitembicyclecolor: this.state.bicycleColor,
      item_custitembicyclesize: this.state.bicycleSize,
      item_custitembicyclespeed: this.state.bicycleSpeed
    };

    var img = this.state.img[0].img;
    var link = this.state.product && this.state.product.item_detailspage_url && this.state.product.item_detailspage_url.value;
    var itemId = this.state.item_id;
    var qty = this.state.quantity;

    var requestParam = "&img=" + encodeURIComponent(img) + "&matrixoption=" + encodeURIComponent(JSON.stringify(matrixOption)) + "&link=" + encodeURIComponent(link) + "&itemId=" + encodeURIComponent(itemId) + "&qty=" + encodeURIComponent(qty);
    requestParam += "&method=add&customer=";
    var customer = getCookie("customid");
    requestParam += customer;

    jquery
      .ajax({
        url: cartUrl + requestParam,
        Cache: false,
        dataType: "jsonp",
      }).done(function (data) {
        self.setState({ loading: false });
        try {
          data = JSON.parse(decodeURIComponent(data));
          if (data.summary && data.summary.status == "SUCCESS") {
            self.forceUpdate();
            self.setState({ quantity: 1 })
            showNotification(
              "Added to cart",
              "success",
              " "
            );
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        } catch (error) {
          console.log("err@fectchcart", error)
        }
      }).fail(function () {
        self.setState({ loading: false });
        showNotification(
          "Sorry",
          "danger",
          "An unknown error occurred. Please try again later"
        );
      })
  }

  handleSelect(e) {
    //To handle select option change
    var self = this;
    this.setState({ [e.id]: e }, function () {
      self.setItemDetails();
    });
  }

  setItemDetails() {
    this.setState({ addToCartEnabled: false });
    var pricelevel = getCookie("pricelevel") || "1";
    var basePriceLevel = "1";
    var optionsSelected = {
      item_custitembicyclesize:
        (this.state.bicycleSize && this.state.bicycleSize.value) || "",
      item_custitembicyclecolor:
        (this.state.bicycleColor && this.state.bicycleColor.value) || "",
      item_custitembicyclespeed:
        (this.state.bicycleSpeed && this.state.bicycleSpeed.value) || "",
      item_custitembicycleaccessorycolor:
        (this.state.accColor && this.state.accColor.value) || "",
      item_custitembicycleaccessorysize:
        (this.state.accSize && this.state.accSize.value) || "",
    }; //Get selected item options

    var childItems = this.state.product
      ? this.state.product["child_items"]
      : {};

    for (var key in childItems) {
      var biSize = childItems[key]["item_custitembicyclesize"].value;
      var biColor = childItems[key]["item_custitembicyclecolor"].value;
      var biSpeed = childItems[key]["item_custitembicyclespeed"].value;
      var accSize = childItems[key]["item_custitembicycleaccessorysize"].value;
      var accColor =
        childItems[key]["item_custitembicycleaccessorycolor"].value;
      //If all selected option match with an item, then its details are set in page
      if (
        biSize == optionsSelected["item_custitembicyclesize"] &&
        biColor == optionsSelected["item_custitembicyclecolor"] &&
        biSpeed == optionsSelected["item_custitembicyclespeed"] &&
        accSize == optionsSelected["item_custitembicycleaccessorysize"] &&
        accColor == optionsSelected["item_custitembicycleaccessorycolor"]
      ) {
        document.title = childItems[key].item_itemid.value;
        var basePrice =
          (childItems[key].price_levels &&
            childItems[key].price_levels[basePriceLevel] &&
            childItems[key].price_levels[basePriceLevel]
              .item___pricing_unitprice.value) ||
          "";
        var yourPrice =
          (childItems[key].price_levels[pricelevel] &&
            childItems[key].price_levels[pricelevel].item___pricing_unitprice &&
            childItems[key].price_levels[pricelevel].item___pricing_unitprice
              .value) ||
          basePrice;

        var price = basePrice;

        this.setState({ name: childItems[key].item_itemid.value });
        this.setState({ item_id: childItems[key].item_internalid.value });
        this.setState({ price: price });
        this.setState({ yourPrice: yourPrice });
        this.setState({
          img: [{ img: childItems[key].item_image_thumbnail_url.value }],
        });
        this.setState({
          description: childItems[key].item_storedescription.value,
        });
        this.setState({
          longdescription:
            childItems[key].item_salesdescription.value ||
            "No Description provided by the seller for this item",
        });

        var availableLocations = [];
        var additionalInfo = [];
        var stockInfo = [];
        var locations = childItems[key].stock_availability;

        for (var i in locations) {
          if (
            locations[i].item_inventorylocation &&
            locations[i].item_inventorylocation.text
          ) {
            var obj = {};
            availableLocations.push(locations[i].item_inventorylocation.text);
            obj.name = locations[i].item_inventorylocation.text;
            obj.text = locations[i].item_locationquantityavailable_text.value;
            if (obj.text.indexOf('>') || obj.text.indexOf('<')) {
              obj.text = obj.text.replace(/</, '< ');
              obj.text = obj.text.replace(/>/, '> ')
            }
            stockInfo.push(obj);
            if (obj.text != "OUT OF STOCK") {
              this.setState({ addToCartEnabled: true });
            }
          }
        }
        additionalInfo.push({
          name: "Available Location",
          text: availableLocations.toString(),
        });
        additionalInfo.push({
          name: "SKU",
          text: childItems[key].item_vendorname.value,
        });
        this.setState({ SKU: childItems[key].item_vendorname.value })
        this.setState({ stockInfo: stockInfo });
        this.setState({ additionalInfo: additionalInfo }, function () {
          this.forceUpdate();
        });
      }
    }
    // this.forceUpdate();
  }

  render() {
    return (
      <React.Fragment>
        <Loader loading={this.state.loading} />
        <Header headermenu={this.headermenu} history={this.props.history} />

        {this.state.itemFound && (
          <div>
            <section>
              <Container className="pt-5">
                <Breadcrumb>
                  <BreadcrumbItem>
                    <a href="/home">Home</a>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <a href={this.state.categoryRoute}>
                      {this.state.category.name}
                    </a>
                  </BreadcrumbItem>
                  <BreadcrumbItem active>{this.state.name}</BreadcrumbItem>
                </Breadcrumb>

                <Row>
                  <Col lg="7" className="order-2 order-lg-1">

                    <SwiperGallery data={this.state.img} />
                  </Col>
                  <Col lg="5" className="pl-lg-4 order-1 order-lg-2">
                    <h1 className="h2 mb-4">{this.state.name}</h1>
                    {!this.state.addToCartEnabled && (<div className="mb-3"><Badge color="danger-light">Out of stock</Badge></div>)}
                    {this.state.addToCartEnabled && (<div className="mb-3"><Badge color="success-light">In Stock</Badge></div>)}
                    <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between mb-4">
                      <ul className="list-inline mb-2 mb-sm-0">
                        {this.state.yourPrice && (
                          <li className="h4 font-weight-light mb-0">
                            <span className="text-dark text-md">
                              Your Price: ${this.state.yourPrice}
                            </span>
                          </li>
                        )}
                        {this.state.price && (
                          <li className="list-inline-item h4 font-weight-light mb-0">
                            <span className="text-gray-500 text-lg">
                              MSRP: ${this.state.price}
                            </span>
                          </li>
                        )}
                      </ul>
                    </div>
                    <p className="mb-4 text-dark">SKU: {this.state.SKU}</p>
                    <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between mb-4 text-muted" dangerouslySetInnerHTML={{
                      //  __html : this.state.longdescription,
                      __html: (this.state.longdescription && (this.state.longdescription).toString()) ?
                        ((this.state.longdescription).toString().replace(/\r\n/gi, "<br/>").replace(/\n/gi, "<br/>")) :
                        (this.state.longdescription)
                    }}>
                    </div>

                    <Form onSubmit={this.handleSubmit}>
                      <Row>
                        {this.state.item_custitembicyclesize.length > 0 ? (
                          <Col sm="6" lg="12" className="detail-option mb-4">
                            <h6 className="detail-option-heading">
                              Size <span>(required)</span>
                            </h6>
                            <Select
                              name="item_custitembicyclesize"
                              id="item_custitembicyclesize"
                              options={this.state.item_custitembicyclesize}
                              autosize={true}
                              defaultValue={
                                this.state.item_custitembicyclesize[0]
                              }
                              className="react-select-container"
                              classNamePrefix="react-select"
                              styles={this.customSelectStyles}
                              isSearchable={false}
                              onChange={(e) => this.handleSelect(e)}
                              value={this.state.bicycleSize}
                            />
                          </Col>
                        ) : (
                          ""
                        )}
                        {this.state.item_custitembicyclecolor.length > 0 ? (
                          <Col sm="6" lg="12" className="detail-option mb-4">
                            <h6 className="detail-option-heading">
                              Color <span>(required)</span>
                            </h6>
                            <Select
                              name="item_custitembicyclecolor"
                              id="item_custitembicyclecolor"
                              options={this.state.item_custitembicyclecolor}
                              autosize={true}
                              defaultValue={
                                this.state.item_custitembicyclecolor[0]
                              }
                              className="react-select-container"
                              classNamePrefix="react-select"
                              styles={this.customSelectStyles}
                              isSearchable={false}
                              onChange={(e) => this.handleSelect(e)}
                              value={this.state.bicycleColor}
                            />
                          </Col>
                        ) : (
                          ""
                        )}
                        {this.state.item_custitembicyclespeed.length > 0 ? (
                          <Col sm="6" lg="12" className="detail-option mb-4">
                            <h6 className="detail-option-heading">
                              Speed <span>(required)</span>
                            </h6>
                            <Select
                              name="item_custitembicyclespeed"
                              id="item_custitembicyclespeed"
                              options={this.state.item_custitembicyclespeed}
                              autosize={true}
                              defaultValue={
                                this.state.item_custitembicyclespeed[0]
                              }
                              className="react-select-container"
                              classNamePrefix="react-select"
                              styles={this.customSelectStyles}
                              isSearchable={false}
                              onChange={(e) => this.handleSelect(e)}
                              value={this.state.bicycleSpeed}
                            />
                          </Col>
                        ) : (
                          ""
                        )}
                        {this.state.item_custitembicycleaccessorysize.length >
                          0 ? (
                          <Col sm="6" lg="12" className="detail-option mb-4">
                            <h6 className="detail-option-heading">
                              Size <span>(required)</span>
                            </h6>
                            <Select
                              name="item_custitembicycleaccessorysize"
                              id="item_custitembicycleaccessorysize"
                              options={
                                this.state.item_custitembicycleaccessorysize
                              }
                              autosize={true}
                              defaultValue={
                                this.state.item_custitembicycleaccessorysize[0]
                              }
                              className="react-select-container"
                              classNamePrefix="react-select"
                              styles={this.customSelectStyles}
                              isSearchable={false}
                              onChange={(e) => this.handleSelect(e)}
                              value={this.state.accSize}
                            />
                          </Col>
                        ) : (
                          ""
                        )}
                        {this.state.item_custitembicycleaccessorycolor.length >
                          0 ? (
                          <Col sm="6" lg="12" className="detail-option mb-4">
                            <h6 className="detail-option-heading">
                              Color <span>(required)</span>
                            </h6>
                            <Select
                              name="item_custitembicycleaccessorycolor"
                              id="item_custitembicycleaccessorycolor"
                              options={
                                this.state.item_custitembicycleaccessorycolor
                              }
                              autosize={true}
                              defaultValue={
                                this.state.item_custitembicycleaccessorycolor[0]
                              }
                              className="react-select-container"
                              classNamePrefix="react-select"
                              styles={this.customSelectStyles}
                              isSearchable={false}
                              onChange={(e) => this.handleSelect(e)}
                              value={this.state.accColor}
                            />
                          </Col>
                        ) : (
                          ""
                        )}

                        <Col sm="12" lg="12" className="detail-option mb-4">
                          <InputGroup className="w-100 mb-4">
                            <Input
                              bsSize="lg"
                              className="detail-quantity"
                              name="quantity"
                              type="number"
                              min="1"
                              onChange={this.handleChange}
                              required
                              value={this.state.quantity}
                            />
                            <InputGroupAddon
                              addonType="append"
                              className="flex-grow-1"
                            >
                              <Button
                                color="dark"
                                block
                                type="submit"
                                disabled={!this.state.addToCartEnabled}
                              >
                                <i className="fa fa-shopping-cart mr-2"></i>
                                {this.state.addToCartEnabled ? "Add to Cart" : "Out of Stock"}
                              </Button>
                            </InputGroupAddon>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                </Row>
              </Container>
            </section>
            <ProductBottomTabs
              longdescription={this.state.longdescription}
              additionalInfo={this.state.additionalInfo}
              stockInfo={this.state.stockInfo}
              stockDetails={this.state.stockDetails}
            />
          </div>
        )}
        {!this.state.itemFound && (
          <div>
            <Jumbotron fluid>
              <Container fluid>
                <p className="lead">Item Not Available</p>
              </Container>
            </Jumbotron>
          </div>
        )}
        <Footer />
      </React.Fragment>
    );
  }
}

export default ItemDetails;
